export default {
  /**
   * @param {Vue}    Vue
   * @param {object} config
   */
  install (Vue, config = {}) {
    Vue.prototype.$remoteSettings = {}

    this.initialize(Vue, config)
  },

  /**
   * @param {Vue}    Vue
   * @param {object} config
   * @param {string} config.settingsUrl
   * @param {object} [config.defaults={}]
   */
  async initialize (Vue, { settingsUrl, defaults = {} }) {
    let remoteSettings = {}

    if (settingsUrl) {
      const response = await fetch(settingsUrl)

      if (!response.ok) {
        throw new Error(
            `Error retrieving user access to features.
           URL: ${settingsUrl}
           Status: ${response.status}
           StatusText: ${response.statusText}`
        )
      }

      remoteSettings = await response.json()
    }

    Vue.prototype.$remoteSettings = { ...defaults, ...remoteSettings }
  }
}
